import { render, staticRenderFns } from "./PortalServiciosView.vue?vue&type=template&id=60fd3544"
import script from "./PortalServiciosView.vue?vue&type=script&lang=ts"
export * from "./PortalServiciosView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports